export default "__VITE_ASSET__21c153dc__"